import store from "../store";

export const getUsersList = async ()=>{
  const users = store.getters.getAgentFirmSorts;
  const getUsers = async ()=>{
    const {users} = await store.dispatch("getAgentSorts");
    return users
  }
  return users.length ? users : await getUsers()
}
